import { gql } from '@apollo/client';
import { FR_EQUIPMENT_CLASS_TYPE_FIELDS, FR_EQUIPMENT_TYPE_FIELDS } from './equipment';
import { FR_MACHINE_TYPE_FIELDS } from './machineType';

export const FR_ASSET_FIELDS = gql`
    fragment fr_AssetFields on IssueAsset {
        __typename
        ... on Machine {
            MachineId
            Name
            SerialNbr
            MachineType {
                ...fr_MachineTypeFields
            }
            MachineModel {
                MachineModelId
                Name
            }
            MachineClass {
                Name
            }
            Organization {
                OrganizationId
                Name
            }
            Asset {
                AssetName
                AssetType
            }
            OperationHours {
                MachineMetricId
                Max
                Latest
                Date
                Source
            }
        }
        ... on Equipment {
            EquipmentId
            Name
            SerialNbr
            Model
            EquipmentType {
                ...fr_EquipmentTypeFields
            }
            EquipmentClass {
                ...fr_EquipmentClassTypeFields
            }
            Organization {
                OrganizationId
                Name
            }
            Asset {
                AssetName
                AssetType
            }
        }
    }
    ${FR_MACHINE_TYPE_FIELDS}
    ${FR_EQUIPMENT_TYPE_FIELDS}
    ${FR_EQUIPMENT_CLASS_TYPE_FIELDS}
`;
